import { useRouter } from 'next/router';

import ChevronLeft from '~/icons/chevron-left.svg';
import { Icon } from '~/shared/components/Icon/Icon';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import styles from '../../../templates/blocks/components/N55Breadcrumb/N55Breadcrumb.module.css';

export const BreadcrumbBack = () => {
	const { translate } = useTranslation();
	const router = useRouter();

	return (
		<button
			className={styles.breadcrumb}
			onClick={() => router.back()}
		>
			<Icon className={styles.icon}>
				<ChevronLeft />
			</Icon>
			<span>{translate('navigation.back')}</span>
		</button>
	);
};
